import { render, staticRenderFns } from "./BannerSimulador.vue?vue&type=template&id=3aa379e6&scoped=true"
import script from "./BannerSimulador.vue?vue&type=script&lang=js"
export * from "./BannerSimulador.vue?vue&type=script&lang=js"
import style0 from "./BannerSimulador.vue?vue&type=style&index=0&id=3aa379e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa379e6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa379e6')) {
      api.createRecord('3aa379e6', component.options)
    } else {
      api.reload('3aa379e6', component.options)
    }
    module.hot.accept("./BannerSimulador.vue?vue&type=template&id=3aa379e6&scoped=true", function () {
      api.rerender('3aa379e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lp/BannerSimulador.vue"
export default component.exports